/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import ContainerFlex from "components/ContainerFlex";
import useApi, { ApiMethod } from "hooks/useApi";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { addSendTokenUnlockCartao } from "redux/features/cartao/desbloqueio-slice";
import {
  setLoading,
  resetLoading,
  setTitleLoading,
} from "redux/ui/loadings-slice";
import { RouteNames } from "routes/routes";
import Endpoints from "services/api/endpoints";
import { showMessage } from "utils/messages";
import KeyboardWrapper from "components/Keyboard";
import Input from "components/input";

import * as St from "./styles";
import { SecurityPageProps } from "models/security";
import { phoneUnmask } from "utils/mask";
import Button from "components/button";

const ClientePushSMS: React.FC<SecurityPageProps> = () => {
  const [input, setInput] = useState("");
  const [value, setValue] = useState("");

  const keyboard = useRef(null);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [timer, setTimer] = useState(60);

  useEffect(() => {
    if (input.length <= 16) {
      setValue(input);
    }
  }, [input]);

  const {
    cartao,
    cartao: { termos, whatsApp },
  } = useAppSelector((state) => state.cartaoDesbloqueio);

  const { typeFlow } = useAppSelector((state) => state.security);

  const {
    cliente: { celular },
  } = useAppSelector((state) => state.cliente);

  const RequestSendTokenWhastsApp = useApi<any>(
    `${Endpoints.notificacao.potEnviaPushSMSWhastsApp}`,
    ApiMethod.POST
  );

  const RequestSendTokenSMS = useApi<any>(
    `${Endpoints.notificacao.potEnviaPushSMS}`,
    ApiMethod.POST
  );

  const RequestSendTokenSMSProposta = useApi<any>(
    `${Endpoints.notificacao.potEnviaPushSMSProposta}`,
    ApiMethod.POST
  );

  const RequestValidaTokenSMS = useApi<any>(
    `${Endpoints.notificacao.putValidaNotificacao}`,
    ApiMethod.PUT
  );

  const RequestActivateCC = useApi<any>(
    `${Endpoints.autorizador.putActivateCC}`,
    ApiMethod.PUT
  );

  useEffect(() => {
    switch (typeFlow) {
      case "desbloqueio":
        handleSendTokenSMS();
        break;
      case "proposta":
        handleSendTokenSMSProposta();
        break;

      default:
        break;
    }
  }, []);

  useEffect(() => {
    timer > 0 && setTimeout(() => setTimer(timer - 1), 1000);
  }, [timer]);

  // Função do Timer do botão SMS
  const requestNewSms = useCallback(async () => {
    setTimer(60);
    try {
      switch (typeFlow) {
        case "desbloqueio":
          handleSendTokenSMS();
          break;
        case "proposta":
          handleSendTokenSMSProposta();
          break;
      }
    } catch (err) {
      console.error(err);
    }
  }, []);

  let countSMS = 1;

  const handleSendTokenSMS = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Carregando, um momento..."));

    try {
      let response;

      if (countSMS === 1) {
        countSMS++;
        response = await RequestSendTokenWhastsApp.callApi({
          tokenCartao: cartao.tokenCartao,
        });
      } else {
        response = await RequestSendTokenSMS.callApi({
          tokenCartao: cartao.tokenCartao,
        });
      }

      const mensagem = response.data;

      if (response.status >= 200 && response.status < 300) {
        await dispatch(addSendTokenUnlockCartao(true));
      } else {
        menssageFeed(
          mensagem ||
            "Não foi possível enviar o token SMS, tente novamente mais tarde!"
        );
      }
    } catch (error) {
      console.log(error);
    }
    dispatch(resetLoading());
  };

  const handleSendTokenSMSProposta = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Enviando SMS Token, um momento..."));

    try {
      await RequestSendTokenSMSProposta.callApi({
        numeroCelular: phoneUnmask(celular),
      });
    } catch (error) {
      menssageFeed(
        "Não foi possível enviar o token SMS, tente novamente mais tarde!"
      );
      history.push(RouteNames.HOME);
    }
    dispatch(resetLoading());
  };

  const handleSubmit = () => {
    handleClick();
  };

  function handleClick() {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Validando informações, um momento..."));

    switch (typeFlow) {
      case "desbloqueio":
        handleValidaToken();
        break;
      case "proposta":
        handleValidaTokenProposta();
        break;
      default:
        break;
    }
  }

  async function handleValidaToken() {
    try {
      dispatch(setTitleLoading("Validando token informado, um momento..."));
      const response = await RequestValidaTokenSMS.callApi({
        tokenCartao: cartao.tokenCartao,
        numeroGerado: value,
      });

      if (response.status >= 200 && response.status < 300) {
        handleUnblockCC();
      } else {
        menssageFeed(
          response.mensagem ||
            "Não foi possível validar o token, tente novamente mais tarde!"
        );
      }
    } catch (error) {
      menssageFeed(
        "Não foi possível validar o token, tente novamente mais tarde!"
      );
      history.push(RouteNames.HOME);
    }
  }

  // A validaçao do Tokem SMS para a proposta e feita no serviço iniciar-proposta
  async function handleValidaTokenProposta() {
    sessionStorage.setItem("@NovaEra:codeVerification", String(value));
    history.push(RouteNames.PROPOSTA);
    dispatch(resetLoading());
  }

  // async function handleActivateCC() {
  //   try {
  //     dispatch(setTitleLoading("Ativando o TeuCard, um momento..."));
  //     const response = await RequestActivateCC.callApi({
  //       tokenCartao: cartao.tokenCartao,
  //       senha: cartao.criarSenha,
  //     });

  //     if (response.status >= 200 && response.status < 300) {
  //       handleUnblockCC();
  //     } else {
  //       menssageFeed(
  //         response.mensagem ||
  //           "Não foi possível ativar o TeuCard, tente novamente mais tarde!"
  //       );
  //     }
  //   } catch (error) {
  //     menssageFeed(
  //       "Não foi possível ativar o TeuCard, tente novamente mais tarde!"
  //     );
  //     history.push(RouteNames.HOME);
  //   }
  // }

  async function handleUnblockCC() {
    try {
      dispatch(setTitleLoading("Desbloqueando o TeuCard, um momento..."));
      const response = await RequestActivateCC.callApi({
        tokenCartao: cartao.tokenCartao,
        senha: cartao.criarSenha,
        optionTermoUso: termos,
        optionWhatsApp: whatsApp,
        origemAcao: "TOTEM",
      });

      if (response.status >= 200 && response.status < 300) {
        menssageSuccess();
      } else {
        menssageFeed(
          response.mensagem ||
            "Não foi possível desbloquear o TeuCard, tente novamente mais tarde!"
        );
      }
    } catch (error) {
      menssageFeed(
        "Não foi possível desbloquear o TeuCard, tente novamente mais tarde!"
      );
      history.push(RouteNames.HOME);
    } finally {
      dispatch(resetLoading());
    }
  }

  const clickToBack = () => {
    history.push(RouteNames.HOME);
  };

  function menssageSuccess() {
    showMessage(
      "success",
      "Teucard desbloqueado!",
      "Parabéns! O teu Teucard foi desbloqueado com sucesso!",
      { timer: 3500, showConfirmButton: false }
    );
    history.push(RouteNames.HOME);
    dispatch(resetLoading());
  }

  function menssageFeed(menssage: string) {
    showMessage("error", "Atenção!", menssage, {
      timer: 5000,
      showConfirmButton: false,
    });
    dispatch(resetLoading());
  }

  return (
    <ContainerFlex center flex={1} horizontal>
      <ContainerFlex center>
        <St.Title>Código Enviado</St.Title>
      </ContainerFlex>

      <ContainerFlex center>
        <St.Description>
          {typeFlow === "proposta"
            ? "Favor digitar o código token recebido por SMS e pressione a tecla verde (ENTRA), para continuar a operação:"
            : "Insira o código enviado para o teu Whatsapp e pressione a tecla verde (ENTRA), para continuar a operação:"}
        </St.Description>
      </ContainerFlex>
      <ContainerFlex width={90} row space end>
        <ContainerFlex width={50}>
          <ContainerFlex marginBottom={10}>
            <Input
              label="Valor"
              style={{
                height: "15%",
                textAlign: "center",
                fontSize: "20px",
                fontWeight: "bold",
              }}
              name="valorInfo"
              value={value}
              onChange={(e) => setValue(e)}
              edit
              disabled
            />
          </ContainerFlex>
          <KeyboardWrapper
            onPressBack={clickToBack}
            keyboardRef={keyboard}
            onChange={setInput}
            typeKeyboard="numeric"
            onPressEnter={() => handleSubmit()}
          />
        </ContainerFlex>

        <ContainerFlex maxWidth={30} row horizontal>
          <ContainerFlex end align="flex-end">
            <Button onClick={requestNewSms} size="large" disabled={timer > 0}>
              {timer > 0 && <span>Novo SMS em {timer}s</span>}
              {timer <= 0 && <span>Solicitar novo SMS</span>}
            </Button>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ClientePushSMS;
